import type { RouteObject } from 'react-router';
import { ContactPage } from './ContactPage';
import { RegistrantChangePage } from './RegistrantChangePage';
import { TransferPage } from './TransferPage';

/** Detail routes (paths without a leading slash). */
export const CORE_ROUTES: RouteObject[] = [
  { path: 'contacts/:registry/:handle', element: <ContactPage /> },
  { path: 'transfers/:id', element: <TransferPage /> },
  { path: 'registrant-changes/:id', element: <RegistrantChangePage /> },
];
